export const PARAM_KEY_VERTICAL_SIGNING = "verticalSigning"
export const VERTICAL_SIGNING_CODE_URL_PARAM = "verticalSigningType"
export const VERTICAL_SIGNING_CONDITION_URL_PARAM = "verticalSigningCondition"
export const VERTICAL_SIGNING_TAGS_URL_PARAM = "verticalSigningTags"
export const VERTICAL_SIGNING_ANTI_TAGS_URL_PARAM = "verticalSigningAntiTags"